import { render, staticRenderFns } from "./Display.vue?vue&type=template&id=10314f2c&scoped=true&"
import script from "./Display.vue?vue&type=script&lang=js&"
export * from "./Display.vue?vue&type=script&lang=js&"
import style0 from "./Display.vue?vue&type=style&index=0&id=10314f2c&lang=scss&scoped=true&"
import style1 from "./Display.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10314f2c",
  null
  
)

export default component.exports